import { render, staticRenderFns } from "./partsFormula.vue?vue&type=template&id=997f86c6&scoped=true&"
import script from "./partsFormula.vue?vue&type=script&lang=js&"
export * from "./partsFormula.vue?vue&type=script&lang=js&"
import style0 from "./partsFormula.vue?vue&type=style&index=0&id=997f86c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997f86c6",
  null
  
)

export default component.exports